export default class LanguageSelector {
  constructor() {
    this.langSelect = document.querySelector('#footer-language-selector select');

    if (!this.langSelect) {
      return;
    }

    this.langSelect.addEventListener('change', this.changeLanguage.bind(this));
  }

  changeLanguage() {
    const selectedValue = this.langSelect.value;

    // Check if the selected language is Spanish
    if (selectedValue === 'es') {
      window.location.href = '/'; // Redirect to the root site
    } else {
      window.location.href = selectedValue;
    }
  }
}
